<template>
    <div class="bg-img">
        <div class="flex w-full middle">
            <div class="vx-col sm:w-1/3 md:w-1/3 lg:w-1/4 xl:w-2/5 mx-auto self-center" >
                <div slot="no-body">
                    <vs-row>
                        <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                            <vs-input
                                name="email"
                                :label="$t('message.email')"
                                v-model="email"
                                class="no-icon-border" style="width: 300px"/>
                        </vs-col>
                    </vs-row>

                    <vs-row class="m-t-2">
                        <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                            <vs-button size="small" @click="onReset()">{{$t('message.send')}}</vs-button>
                        </vs-col>
                    </vs-row>

                    <vs-row class="m-t-2">
                        <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                            {{$t('message.goSignIn')}}&ensp;<a href="../pages/login">{{$t('message.clickHere')}}</a>
                        </vs-col>
                    </vs-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
export default {
    data() {
        return {
            email:'',
            langOpt:[
                {
                    text:'English',
                    value:'en'
                },
                {
                    text:'繁體中文',
                    value:'zh'
                },
                {
                    text:'简体中文',
                    value:'zh_cn'
                }
            ],
            lang:'',

        }
    },
    created() {
        this.$vs.loading.close()
        this.lang = this.$cookies.get('lang');
    },
    methods:{
        ...mapActions(["getUser"]),
        onReset(){
            let url = process.env.VUE_APP_API_BASEURL + '/api/auth/forget';
            fetch(url,{
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, *!/!*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email:this.email
                })
            }).then((response)=>{
                return response.json()
            }).then((res)=>{
                if(res.responseCode === 200){
                    this.$vs.notify({
                        title:'提示',
                        text: this.$t('message.checkEmail'),
                        icon: 'done',
                        color:'success',
                        position:'top-center',
                        time: 3000
                    });
                }else{
                    this.$vs.notify({
                        title:'提示',
                        text: this.$t('message.errorMsg'),
                        icon: 'clear',
                        color:'danger',
                        position:'top-center',
                        time: 3000
                    });
                }
            })
        },
    },
    watch:{

    }
}
</script>

<style lang="scss">
.middle{
    width: 100%;
    height: 62vh;
    background-color: rgba(255, 255, 255, 0.4);
}

</style>
